import { LimitConfigurationInput, LimitCreateMutationVariables } from '@occc/graphql';

import { Operation } from '../types';

type CreateLimitOperationType = Operation<'limitCreate', LimitCreateMutationVariables>;

export const makeCreateLimitOperation = (
  offerId: string,
  configuration: LimitConfigurationInput,
): CreateLimitOperationType => {
  return {
    name: 'limitCreate',
    variables: {
      input: {
        offerId,
        configuration,
      },
    },
  };
};
